import { templatePolicies as policies } from 'helpers';
import Schema from './schema';


export default class Template extends Schema {

  constructor(values) {
    const dtoDefinition = {
      worktemplate_id: 0,
      name: '',
      description: '',
      type: '',
      type_template: 'SI',
      inventory_id: '',
      inventory_ask: false,
      datamodel_id: 0,
      datamodel_ask: false,
      proyect_id: null,
      playbook_id: '',
      credentials_id: [],
      credentials_ask: false,
      forks: 0,
      limit: '',
      limit_ask: false,
      detail_level: 0,
      work_tags: [],
      work_tags_ask: false,
      omit_tags: [],
      omit_tags_ask: false,
      tags: [],
      instance_groups: 0,
      job_slicing: 0,
      timeout: 0,
      show_changes: false,
      show_changes_ask: false,
      enable_privileges: false,
      alow_exec_callbaks: false,
      activate_concurrent_works: false,
      use_event_cache: false,
      variables: '',
      wf_definition: "",
      user_interaction: [
        {
          var_name: '',
          desc: '',
          type: '',
          number: '',
          range: [0, 0],
          options: [
            { value: '', name: '' }
          ]
        }
      ],
      notifications: [
        {
          user: '',
          tipo: '',
        },
      ],
      command_line: '',
    };

    super(policies, values, dtoDefinition);
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.setDefaultValues(data);

    return this;
  }

  formatResponse() {
    const templateTags = {
      tags: this.__validJsonParse(this.values.tags).map(s => s.value),
      tagsJob: this.__validJsonParse(this.values.work_tags).map(s => s.value),
      tagsSkip: this.__validJsonParse(this.values.omit_tags).map(s => s.value),
    }

    const formatedValues = this.getValuesFormatted();

    let ui= this.values.user_interaction == null || this.values.user_interaction == "{}" ? [] : JSON.parse(this.values.user_interaction);

    for(let i=0; i< formatedValues.pollings.length; i++){
      const item = formatedValues.pollings[i];
      if ( item.pollingType == "option"){   
        formatedValues.pollings[i].pollingOptionsValues = [];

        for ( let j=0; j<ui[i].options.length;j++){

          formatedValues.pollings[i].pollingOptionsValues.push({
            pollingOptionValue: ui[i].options[j].value,
            pollingOptionDescription: ui[i].options[j].name
          });
        }
      }
    } 

    return {
      jobType: this.values.type,
      ...formatedValues,
      ...templateTags
    }
  }

  formatRequest(data) {
    // this.values = this.dtoDefinition;
    this.values = this.formatRequestValues(data);
    // this.setDefaultValues(data);
    this.values.type = data.jobType;


    for(let i=0; i< data.pollings.length; i++){
      const item = data.pollings[i];
      if ( item.pollingType == "option"){
        this.values.user_interaction[i].options = [];
        
        for ( let j=0; j<item.pollingOptionsValues.length;j++){
          this.values.user_interaction[i].options.push(
            { 
              value: item.pollingOptionsValues[j].pollingOptionValue, 
              name: item.pollingOptionsValues[j].pollingOptionDescription
            });
        }
        
      }
    }

    ['tags', 'work_tags', 'omit_tags'].forEach(k => {
      this.values[k] = this.values[k].map(value => ({ display: value, value: value }));
    });
    this.values.credentials_id = data.credential ;
    return this.values;
  }
}
